import type { PrevNextNavProps } from "./prev-next-nav.type";

import { PrevNextNavButton } from "./prev-next-nav-item";

import "./prev-next-nav.style.less";

export const PrevNextNav = <Data = unknown,>({
  previous,
  next,
  onClick,
}: PrevNextNavProps<Data>) => {
  return (
    <div className="prev-next-nav">
      <PrevNextNavButton type="previous" item={previous} onClick={onClick} />
      <PrevNextNavButton type="next" item={next} onClick={onClick} />
    </div>
  );
};
